module.exports = __webpack_public_path__ + "dd9069d0bd5bb9621d02926efaad40e4.mp4";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/trailer-preview-460.mp4
// module id = 655
// module chunks = 0